import { useCurrentUserType } from '../../../hooks/useCurrentUserType';
import { UserType } from '../../../consts/userType';

export const useHasAccessToSchedules = () => {
  const userType = useCurrentUserType();

  return [UserType.Moderator, UserType.TaPilot].includes(userType as UserType);
};
